import { render, staticRenderFns } from "./InsightResult.vue?vue&type=template&id=8d7324ee&"
import script from "./InsightResult.vue?vue&type=script&lang=js&"
export * from "./InsightResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports